export default __webpack_public_path__ + "static/media/klima-open.47281683.gif";